do ->

  get_tab_code_by_hash = () ->
    hash = window.location.hash.match /tab=([^&]+)/
    tab_code = null
    if _.isArray(hash) && hash[1]?
      tab_code = hash[1]
    return tab_code

  set_tab_code_to_hash = (tab_code) ->
    if !tab_code
      return

    current_hash = window.location.hash.substr(1)
    if !current_hash
      new_hash = "tab=#{tab_code}"
    else if current_hash.match /tab=([^&]+)/
      new_hash = current_hash.replace /tab=([^&]+)/, "tab=#{tab_code}"
    else
      new_hash = current_hash + "&tab=#{tab_code}"

    if new_hash?
      setTimeout ( ->
        window.location.replace '#' + new_hash
      ), 0

  show_tab = (tab_code) ->
    if tab_code
      tab_switcher = $ "[data-toggle='tab'][href='##{tab_code}']"
      if tab_switcher.length and !tab_switcher.attr 'data-disable-tab-redirect'
        tab_switcher.tab 'show'

  $ ->

    show_tab get_tab_code_by_hash()

    $(document).on 'shown.bs.tab', (e) ->
      tab = $ e.target
      if tab.attr 'data-set-hash'
        code = tab.attr('aria-controls')
        set_tab_code_to_hash code